import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { MarkGroceryAsDoNotChargeInput } from '@/models/grocery';

export const markGroceryAsDoNotCharge = async ({ orderId, reason, notes }: MarkGroceryAsDoNotChargeInput) => {
  const response = await mutationExecute({
    variables: {
      orderId,
      reason,
      notes,
    },
    mutation: graphql(`
      mutation MarkGroceryAsDoNotCharge($orderId: String!, $reason: String!, $notes: String) {
        markGroceryAsDoNotCharge(orderId: $orderId, reason: $reason, notes: $notes) {
          id
        }
      }
    `),
  });

  return !!response.data?.markGroceryAsDoNotCharge;
};
